export default __webpack_public_path__ + "static/media/teams-icon.176a34ed.png";